export const UPLOAD_FILE_PENDING = 'infomail/fileUpload/UPLOAD_FILE_PENDING';
export const UPLOAD_FILE_SUCCESS = 'infomail/fileUpload/UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_ERROR = 'infomail/fileUpload/UPLOAD_FILE_ERROR';
export const UPLOAD_FILE_RESET = 'infomail/fileUpload/UPLOAD_FILE_RESET';
